
  var _styles = {
  "pre-joined-v1": {
    "position": "relative",
    "width": "9.57333rem",
    "height": "7.65333rem",
    "borderRadius": "0.32rem",
    "overflow": "hidden"
  },
  "pre-joined-v1__bg": {
    "position": "absolute",
    "top": "0.02667rem",
    "left": "0.02667rem",
    "width": "9.52rem",
    "height": "7.6rem",
    "borderRadius": "0.32rem",
    "zIndex": 0
  },
  "pre-joined-v1__content": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "9.57333rem",
    "height": "7.65333rem",
    "zIndex": 2
  },
  "pre-joined-v1__header": {
    "position": "absolute",
    "top": "0.32rem",
    "left": "0.32rem",
    "width": "8.93333rem",
    "height": "0.48rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center"
  },
  "pre-joined-v1__title": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "baseline"
  },
  "pre-joined-v1__title-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.4rem",
    "lineHeight": "0.48rem",
    "fontWeight": "400",
    "color": "rgb(0,28,55)"
  },
  "pre-joined-v1__title-amount": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.42667rem",
    "lineHeight": "0.48rem",
    "fontWeight": "500",
    "color": "rgb(255,45,25)"
  },
  "pre-joined-v1__reselect": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "pre-joined-v1__reselect-text": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "color": "rgb(85,85,85)",
    "marginRight": "0.05333rem"
  },
  "pre-joined-v1__reselect-arrow": {
    "width": "0.29333rem",
    "height": "0.29333rem"
  },
  "pre-joined-v1__panel": {
    "position": "absolute",
    "top": "0.92rem",
    "left": "0.32rem",
    "display": "flex",
    "flexDirection": "column",
    "width": "8.93333rem",
    "height": "3.61333rem",
    "paddingTop": "0.57333rem"
  },
  "pre-joined-v1__panel-bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "width": "8.93333rem",
    "height": "3.61333rem",
    "zIndex": 0
  },
  "pre-joined-v1__hand": {
    "position": "absolute",
    "top": "0.28rem",
    "right": "0.13333rem",
    "width": "1.38667rem",
    "height": "1.38667rem",
    "zIndex": 2
  },
  "pre-joined-v1__top-block": {
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "column",
    "paddingLeft": "0.21333rem",
    "marginBottom": "0.37333rem"
  },
  "pre-joined-v1__meter-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "flex-end",
    "marginBottom": "0.2rem"
  },
  "pre-joined-v1__meter-num-box": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "height": "0.8rem",
    "overflow": "visible",
    "marginRight": "0.02667rem"
  },
  "pre-joined-v1__meter-num": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.8rem",
    "fontWeight": "700",
    "color": "rgb(17,17,17)"
  },
  "pre-joined-v1__meter-unit": {
    "fontFamily": "MTfin-bold2.0",
    "fontSize": "0.29333rem",
    "fontWeight": "700",
    "color": "rgb(17,17,17)",
    "marginRight": "0.16rem"
  },
  "pre-joined-v1__meter-sub": {
    "fontFamily": "PingFang SC",
    "fontSize": "0.29333rem",
    "fontWeight": "400",
    "color": "rgb(17,17,17)"
  },
  "pre-joined-v1__bar": {
    "display": "flex",
    "flexDirection": "row",
    "width": "8.05333rem",
    "height": "0.21333rem",
    "borderRadius": "13.32rem",
    "backgroundColor": "rgb(255,222,228)"
  },
  "pre-joined-v1__bar-fill": {
    "height": "0.21333rem",
    "borderRadius": "13.32rem"
  },
  "pre-joined-v1__actions": {
    "position": "relative",
    "zIndex": 1,
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "8.93333rem",
    "height": "1.28rem"
  },
  "pre-joined-v1__cta": {
    "position": "relative",
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "5.52rem",
    "height": "1.28rem",
    "borderRadius": "13.32rem",
    "overflow": "hidden"
  },
  "pre-joined-v1__cta-bg": {
    "position": "absolute",
    "top": 0,
    "left": 0,
    "right": 0,
    "bottom": 0,
    "zIndex": 0
  },
  "pre-joined-v1__cta-text": {
    "position": "relative",
    "zIndex": 1,
    "fontFamily": "PingFang SC",
    "fontSize": "0.4rem",
    "fontWeight": "500",
    "color": "rgb(255,255,255)"
  },
  "pre-joined-v1__notice": {
    "position": "absolute",
    "top": "4.45333rem",
    "left": "0.32rem",
    "width": "8.93333rem",
    "height": "0.48rem",
    "overflow": "hidden"
  },
  "pre-joined-v1__landmark-section": {
    "position": "absolute",
    "top": "5.14667rem",
    "left": "0.32rem",
    "display": "flex",
    "flexDirection": "column",
    "width": "8.93333rem",
    "height": "2.16rem"
  },
  "pre-joined-v1__landmark-header": {
    "width": "8.92rem",
    "height": "0.41333rem",
    "marginBottom": "0.14667rem"
  },
  "pre-joined-v1__landmark-row": {
    "display": "flex",
    "flexDirection": "row",
    "width": "8.93333rem",
    "justifyContent": "space-between"
  }
};



  module.exports = _styles;
  